/** Personal data masked before a model call (M29 WP-REDACT, SEC-001). Mirrors `backend/app/core/constants/pii_kinds.py` (checked by `backend/tests/core/test_pii_kinds_mirror.py`). */

/** `PiiKind` values, in the order the backend declares them. */
export const PII_KIND_VALUES = ["mobile", "email", "national_id", "address", "card_bank", "gov_id"] as const;

/** The word the model reads in place of a masked value, per kind. */
export const PII_MASK_LABELS = {
  mobile: "MOBILE",
  email: "EMAIL",
  national_id: "NATIONAL_ID",
  address: "ADDRESS",
  card_bank: "ACCOUNT",
  gov_id: "GOV_ID",
} as const;

/** `[MOBILE]`: how a masked value is written (`{label}` is replaced). */
export const PII_MASK_TEMPLATE = "[{label}]" as const;

/** Recogniser priority when two kinds match the same characters: the earlier one keeps them. */
export const PII_KIND_ORDER = ["card_bank", "national_id", "gov_id", "mobile", "email", "address"] as const;

/** Longest text the Settings › Privacy preview takes. */
export const PII_PREVIEW_MAX_CHARS = 2000 as const;
